<nz-range-picker
  #dateRangePicker
  [nzFormat]="dateFormat"
  [(ngModel)]="selectedDateRange"
  [nzDisabledDate]="disabledDates()"
  [nzRanges]="presetRanges()"
  [nzAllowClear]="false"
  (nzOnOpenChange)="handleOpenChange($event)"
/>
